module.exports = __webpack_public_path__ + "img/hero.eee822b4.jpg";